export enum DispatchActions {
	OPEN_CART = 'OPEN_CART',
	CLOSE_CART = 'CLOSE_CART',
	ADD_TO_CART = 'ADD_TO_CART',
	UPDATE_CART = 'UPDATE_CART',
	UPDATE_TOTAL_AMOUNT = 'UPDATE_TOTAL_AMOUNT',
}
